module.exports = __webpack_public_path__ + "static/media/me_small.894a6b4e.jpg";